// Room type catalogue for the house floor-plan editor (Stage 9b).
//
// A detected face becomes a room; the user assigns a type, which drives the
// default Russian label and the fill tint used in the overlay and on the site
// footprint. Pure data + tiny helpers — no DOM, no Konva.

export const ROOM_TYPES = [
  { key: "living", label: "Гостиная", color: "#fde68a" }, // amber-200
  { key: "bedroom", label: "Спальня", color: "#bfdbfe" }, // blue-200
  { key: "kitchen", label: "Кухня", color: "#fbcfe8" }, // pink-200
  { key: "bathroom", label: "Санузел", color: "#a7f3d0" }, // emerald-200
  { key: "hall", label: "Коридор", color: "#e5e7eb" }, // gray-200
  { key: "other", label: "Комната", color: "#ddd6fe" }, // violet-200
]

export const DEFAULT_ROOM_TYPE = "other"

const BY_KEY = new Map(ROOM_TYPES.map((t) => [t.key, t]))

export function roomType(key) {
  return BY_KEY.get(key) ?? BY_KEY.get(DEFAULT_ROOM_TYPE)
}

// The label shown for a room: the user's custom name if set, else the type's
// default label ("Спальня", "Комната", …).
export function roomLabel(room) {
  const name = room?.name?.trim()
  if (name) return name
  return roomType(room?.type).label
}

export function roomColor(room) {
  return roomType(room?.type).color
}
